// utils/timeFormatter.js
export const formatTime = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  if (minutes > 0 && seconds > 0) {
    return `${minutes} min${minutes > 1 ? "s" : ""} ${seconds} sec${seconds > 1 ? "s" : ""}`;
  } else if (minutes > 0) {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  } else {
    return `${seconds} sec${seconds > 1 ? "s" : ""}`;
  }
};
